import React from 'react';
import Text from './base';

const H1 = props => <Text defaultTag="h1" variant="h1" {...props} />;

export default H1;
